import { create } from 'zustand';
import { initialFilterState } from '../components/filter/filterList/const';

const state = {
    ...initialFilterState,
    page: 1,
    limit: 10,
};

export const useFilter = create((set) => ({
    ...state,
    setFilter: (newState) => set((state) => ({ ...state, ...newState })),
    onClearFilter: () =>
        set(() => ({
            ...state,
        })),
    resetFilter: () => set(() => ({ ...state })),
}));
